import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';
import ManageDepartments from 'src/components/Elements/ManageDepartments';

const AccountManagementModal = () => (
  <ModalBase
    name={MODALS.manageDepartments}
    size={MODALS_SIZE.small}
    form={FORM.get_departments}>
    <ManageDepartments />
  </ModalBase>
);

export default AccountManagementModal;
//
